export const accidentPaths: Record<string, (string | number)[]> = {
  'Accidental Death': ['details', 'addons', 'Accidental Death'],
  Surgery: ['details', 'addons', 'Surgery'],
  'Diagnostic Exam': ['details', 'addons', 'Diagnostic Exam (per year)'],
  'Hospital Admission': ['details', 'addons', 'Hospital Admission (per year)'],
};

export const hospitalPaths: Record<string, (string | number)[]> = {
  'First Day - Hospital': ['details', 'addons', 'First Day - Hospital'],
  'First Day - ICU': ['details', 'addons', 'First Day - ICU'],
  'Daily Hospital Confinement': ['details', 'addons', 'Daily Hospital Confinement'],
  'Emergency Room': ['details', 'addons', 'Emergency Room'],
};

export const criticalPaths: Record<string, (string | number)[] | null> = {
  'Maximum Benefit': ['details', 'addons', 'Maximum Benefit'],
  'Major Condition Payout': ['details', 'addons', 'Major Condition Payout'],
  'Yearly Wellness Benefit': ['details', 'addons', 'Yearly Wellness Benefit'],
};

export const dentalPaths: Record<string, (string | number)[]> = {
  'Annual Max Benefit': ['details', 'addons', 'Annual Max Benefit'],
  Deductible: ['details', 'addons', 'Deductible '],
  'Checkups/Cleanings': ['details', 'addons', 'Checkups/Cleanings'],
  'Basic Care': ['details', 'addons', 'Basic Care'],
  'Major Care': ['details', 'addons', 'Major Care'],
};

export const visionPaths: Record<string, (string | number)[]> = {
  'Exam Copay': ['details', 'coverage', 'Exams Copay'],
  'Materials Copay': [
    'details',
    'coverage',
    'Materials Copay (waived for contact lenses)',
  ],
  'Eye Exams': ['details', 'coverage', 'Eye Exam Covereage - In-Network'],
  'Single Vision Lens': [
    'details',
    'coverage',
    'Single Vision Lenses - In-Network',
  ],
  Frames: ['details', 'addons', 'Frames'],
};

export const healthPaths: Record<string, (string | number)[] | null> = {
  'Network Type': ['type'],
  Deductible: ['details', 'coverage', 'Individual Deductible (In-Network)'],
  'Office visits': ['details', 'coverage', 'Primary Care Visit (In-Network)'],
  'Generic Drugs': ['details', 'coverage', 'Generic Drugs (In-Network Pharmacy)'],
  'Referrals required': null,
};
